app.service('accountSM', ['crudService', function (crudService) {
	let isPwdTemp;
	let isPwdDeprecated;
	return {
		getData: function() {
			return crudService.get('/account');
		},
		app: function() {
			return crudService.get('/account/app');
		},
		pwdTemporary: function() {
			if (!isPwdTemp) {
				isPwdTemp = crudService.post('/account/password_temporary/check');
			}

			return isPwdTemp;
		},
		firstUse: function() {
			return crudService.get('/account/first_use/check');
		},
		setFirstUse: function(firstUse) {
			return crudService.post('/account/first_use/set', {
				first_use : firstUse
			});
		},
		pwdDeprecated: function() {
			if (!isPwdDeprecated) {
				isPwdDeprecated = crudService.post('/account/password_deprecated/check');
			}

			return isPwdDeprecated;
		},
		pwdTemporaryOrDeprecated: function() {
			if (!isPwdTemp) {
				isPwdTemp = crudService.post('/account/password_temporary/check');
			}

			if (isPwdTemp){
				return isPwdTemp;
			}

			if (!isPwdDeprecated) {
				isPwdDeprecated = crudService.post('/account/password_deprecated/check');
			}

			return isPwdDeprecated;
		},
		/**
		 * L'utilisateur peut-il effectuer cette action
		 * @param {String} 	action
		 */
		hasAction: function(action) {
			return crudService.get('/account/check_action', {action:action});
		},
		/**
		 * Permission de l'utilisateur sur des sites / un contrat
		 * @param {String} 	action
		 * @param {Array} 	sitesID
		 * @param {Int}		contratID
		 */
		allowOnTree: function(action, sitesID, contratID) {
			var data = {
				action: action,
				sitesID: [sitesID],
				contratID: contratID
			};
			return crudService.get('/account/allow_on_tree', data);
		},
		hasSettingActivated: function(slug, user_id) {
			return crudService.post('account/check_setting', {
				slugSetting: slug,
				userId: user_id
			});
		},
		hasOptionReloadDemIntervention: function() {
			return crudService.post('/account/reload-demande-intervention');
		},
		getSitesAccessiblesPourContratProfil: function(contratId, profil) {
			return crudService.get('/account/nodes-avaialbles-contrat-profil', {
				profil: profil,
				contrat_id: contratId
			});
		}
	};
}]);
